export default class GtmTracking {
  constructor({
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
    eventProperty,
    eventNonInteraction,
    eventName,
  } = {}) {
    this.dataLayer = window.dataLayer;
    this.eventCategory = eventCategory || 'mkt-userEngagement';
    this.eventAction = eventAction || '';
    this.eventLabel = eventLabel || '';
    this.eventValue = eventValue || '';
    this.eventProperty = eventProperty || '';
    this.eventNonInteraction = eventNonInteraction || false;
    this.eventName = eventName || 'gtmEvent';
  }

  send = () => {
    this.dataLayer.push({
      eventCategory: this.eventCategory,
      eventAction: this.eventAction,
      eventLabel: this.eventLabel,
      eventValue: this.eventValue,
      eventProperty: this.eventProperty,
      eventNonInteraction: this.eventNonInteraction,
      event: this.eventName,
    });
  };
}

export const sendGtmTrackingEvent = (data, isEvent = true) => {
  if (window.dataLayer) {
    if (isEvent) {
      new GtmTracking(data).send();
    } else {
      window.dataLayer.push(data);
    }
  }
};
